RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.PaymentEntry = RivalIQ.views.ItemView.extend({
        template: '#paymentEntryTemplate',

        events: {
            'click .x-add-payment-details': 'onUpdateCard'
        },

        onUpdateCard: function () {
            const me = this;

            RivalIQ.execute('payment:start', {
                updateCard: true,
                successModalTimeout: 0,
                plan: RivalIQ.state.account.get('plan'),
                successCallback: function (response) {
                    const token = response.get('token');
                    me.currentCard = token.card;
                    me.render();

                    RivalIQ.execute('alert:info', 'Thanks, your account will be updated shortly.', {
                        autoDestructDelay: -1
                    });

                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
            });
        },

        templateHelpers: function () {
            const me = this;

            return {
                currentCard: me.currentCard
            };
        },

        initialize: function () {
            const me = this;
            me.currentCard = me.options.currentCard;
        }
    });

});
